import featureChords from '../../../assets/images/feature-chords.jpg';
import featureTranspose from '../../../assets/images/feature-transpose.jpg';
import featureCollab from '../../../assets/images/feature-collab.jpg';

const features = [
  {
    icon: 'ri-music-2-line',
    title: 'Biblioteca de Cifras',
    desc: 'Organize todas as músicas do seu grupo com cifras completas, tags e categorias. Busca inteligente e acesso rápido.',
    img: featureChords,
  },
  {
    icon: 'ri-arrow-up-down-line',
    title: 'Transposição Automática',
    desc: 'Mude o tom com um clique. As cifras são recalculadas instantaneamente.',
    img: featureTranspose,
  },
  {
    icon: 'ri-team-line',
    title: 'Colaboração ao Vivo',
    desc: 'Sincronize toda a banda em tempo real. O líder controla o ritmo, os músicos seguem — como uma partitura viva.',
    img: featureCollab,
  },
];

const FeaturesSection = () => (
  <section id="features" className="bg-[#0A0A0F] py-28 px-6 md:px-10">
    <div className="max-w-7xl mx-auto">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6">
        <div>
          <span className="inline-block text-[#C8A96E] text-xs uppercase tracking-widest mb-4">Funcionalidades</span>
          <h2 className="text-4xl md:text-5xl font-light text-white leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            Tudo que você precisa<br />
            <strong>para o louvor.</strong>
          </h2>
        </div>
        <p className="text-white/40 text-sm max-w-xs leading-relaxed">
          Organize cifras, tons e a colaboração do grupo com ferramentas pensadas para músicos de louvor.
        </p>
      </div>

      {/* Feature Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {features.map((f) => (
          <div
            key={f.title}
            className="group bg-[#111111] border border-white/5 rounded-2xl overflow-hidden hover:border-white/15 transition-all duration-500"
          >
            <div className="relative h-52 overflow-hidden">
              <img
                src={f.img}
                alt={f.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#111111] via-[#111111]/40 to-transparent"></div>
            </div>
            <div className="p-6">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#C8A96E]/10 mb-4">
                <i className={`${f.icon} text-[#C8A96E] text-lg`}></i>
              </div>
              <h3 className="text-white font-semibold text-lg mb-2">{f.title}</h3>
              <p className="text-white/40 text-sm leading-relaxed">{f.desc}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Secondary features row */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6">
        {[
          { icon: 'ri-notification-3-line', title: 'Avisos ao vivo', desc: 'Mudança, pausa, tom' },
        ].map((item) => (
          <div
            key={item.title}
            className="bg-[#111111] border border-white/5 rounded-xl p-5 hover:border-white/15 transition-all duration-300"
          >
            <div className="w-8 h-8 flex items-center justify-center mb-3">
              <i className={`${item.icon} text-[#C8A96E] text-xl`}></i>
            </div>
            <p className="text-white text-sm font-medium">{item.title}</p>
            <p className="text-white/30 text-xs mt-1">{item.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default FeaturesSection;
